"use client";

import { createContext, useContext, type ReactNode } from "react";
import { XError } from "@/utils/error.utils";
import type { VerifiedSession } from "@/utils/verifiedSession.utils";
const SignedInSessionContext = createContext<VerifiedSession | null>(null);
export function SignedInSessionProvider({
  session,
  children
}: {
  session: VerifiedSession;
  children: ReactNode;
}) {
  return <SignedInSessionContext.Provider value={session} data-sentry-element="SignedInSessionContext.Provider" data-sentry-component="SignedInSessionProvider" data-sentry-source-file="useSignedInSession.tsx">
            {children}
        </SignedInSessionContext.Provider>;
}
export function useSignedInSession(): VerifiedSession {
  const session = useContext(SignedInSessionContext);
  if (!session) {
    throw new XError({
      message: "useSignedInSession must be used within AuthGuard"
    });
  }
  return session;
}